function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmlcancelado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9e9e0"
    },
    d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074 c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d9d7ca"
    },
    points: "37.5,0.151 37.5,12 49.349,12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f29c1f"
    },
    d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M19.379,48.105L21.936,53h-1.9l-1.6-3.801h-0.137L16.576,53h-1.9l2.557-4.895l-2.721-5.182h1.873 l1.777,4.102h0.137l1.928-4.102H22.1L19.379,48.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M31.998,42.924h1.668V53h-1.668v-6.932l-2.256,5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668 l2.994,6.891L31.998,42.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M37.863,42.924v8.832h4.635V53h-6.303V42.924H37.863z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f29c1f"
    },
    d: "M15.5,24c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l6-6 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-6,6C16.012,23.902,15.756,24,15.5,24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f29c1f"
    },
    d: "M21.5,30c-0.256,0-0.512-0.098-0.707-0.293l-6-6c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l6,6c0.391,0.391,0.391,1.023,0,1.414C22.012,29.902,21.756,30,21.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f29c1f"
    },
    d: "M33.5,30c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l6-6 c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-6,6C34.012,29.902,33.756,30,33.5,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f29c1f"
    },
    d: "M39.5,24c-0.256,0-0.512-0.098-0.707-0.293l-6-6c-0.391-0.391-0.391-1.023,0-1.414 s1.023-0.391,1.414,0l6,6c0.391,0.391,0.391,1.023,0,1.414C40.012,23.902,39.756,24,39.5,24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f29c1f"
    },
    d: "M24.5,32c-0.11,0-0.223-0.019-0.333-0.058c-0.521-0.184-0.794-0.755-0.61-1.276l6-17 c0.185-0.521,0.753-0.795,1.276-0.61c0.521,0.184,0.794,0.755,0.61,1.276l-6,17C25.298,31.744,24.912,32,24.5,32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlcancelado);
export default __webpack_public_path__ + "static/media/xmlcancelado.1a3b9a757aaee11f5fc538076d0cd5be.svg";
export { ForwardRef as ReactComponent };